import { Component, FormEventHandler } from 'react'
import * as styles from 'styles/atoms/inputs/OldRadioButton.css'
import { Option, QAMarked } from 'interfaces/component'

export type OldRadioButtonProps<TValue = string> = Option<TValue> & QAMarked & {
  checked: boolean
  name: string
  onChange: FormEventHandler<HTMLElement>
  autoFocus?: boolean
}

/**
 * @deprecated
 * Use RadioButton with react-hook-form
 */
class OldRadioButton extends Component<OldRadioButtonProps, {}> {
  render () {
    const {
      label,
      value,
      checked,
      name,
      onChange,
      qaMarker,
      ...inputProps
    } = this.props

    return (
      <div className={ styles.root } data-qa-marker={ qaMarker }>
        <label data-qa-type='label' className={ styles.label }>
          <input
            data-qa-type='radio'
            className={ styles.radioInput }
            name={ name }
            type='radio'
            value={ value }
            checked={ checked }
            onChange={ onChange }
            { ...inputProps }
          />
          { label }
        </label>
      </div>
    )
  }
}

export default OldRadioButton
